module.exports = __webpack_public_path__ + "assets/img/task-info.8c075360.svg";